// extracted by mini-css-extract-plugin
export default {"color":"style_color__1qHAf","fadein":"style_fadein__W1FPP"};